import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import './AddressAndServiceDetailSection.scss';
import { Col, Row } from 'antd';
import { HistoryOrderDetailsEntity } from 'types/dto/order';
import { DATE_WITH_DAY_MM_DD_FORMAT, TIME_FORMAT } from 'constants/consts';

interface AddressAndServiceDetailSectionProps {
  orderData: HistoryOrderDetailsEntity;
}

const AddressAndServiceDetailSection: React.FC<
  AddressAndServiceDetailSectionProps
> = ({ orderData }) => {
  const { t } = useTranslation('order_history');

  const formatDate = (iso?: string) => {
    return iso ? dayjs(iso).format(DATE_WITH_DAY_MM_DD_FORMAT) : '';
  };

  const formatTime = (iso?: string) => {
    return iso ? dayjs(iso).format(TIME_FORMAT) : '';
  };

  return (
    <div className="address-service-detail-section-container">
      {/* Header */}
      <div className="vls-section-title">{t('addressAndServiceDetails')}</div>

      <Row gutter={16}>
        {/* Address Section */}
        <Col className="address-content" xs={24} md={9}>
          <div className="address-area">
            {orderData.collectionArea && (
              <div className="address-line">{orderData.collectionArea}</div>
            )}
            {orderData.collectionDistrict && (
              <div className="address-line">{orderData.collectionDistrict}</div>
            )}
          </div>
          <div className="address-line">
            {orderData.collectionAddress || ''}
          </div>
        </Col>

        {/* Service Details Grid */}
        <Col className="service-details-grid" xs={24} md={15}>
          <div className="detail-section">
            <div className="detail-label">{t('collectionDate')}</div>
            <div className="detail-value">
              {formatDate(orderData.collectionStartDate)}
            </div>
            <div className="detail-value time">{`${formatTime(
              orderData.collectionStartDate
            )} - ${formatTime(orderData.collectionEndDate)}`}</div>
          </div>

          <div className="detail-section">
            <div className="detail-label">{t('deliveryDate')}</div>
            <div className="detail-value">
              {formatDate(orderData.deliveryStartDate)}
            </div>
            <div className="detail-value time">{`${formatTime(
              orderData.deliveryStartDate
            )} - ${formatTime(orderData.deliveryEndDate)}`}</div>
          </div>

          <div className="detail-section">
            <div className="detail-label">
              {t('collectionAndDeliveryMethod')}
            </div>
            <div className="detail-value">
              {orderData.pickUpMethodName || '-'}
            </div>
          </div>

          {orderData.customerRemark && (
            <div className="detail-section">
              <div className="detail-label">{t('customerRemarks')}</div>
              <div className="detail-value">
                {orderData.customerRemark || '-'}
              </div>
            </div>
          )}

          {orderData.remarkToCustomer && (
            <div className="detail-section">
              <div className="detail-label">{t('remarksToCustomer')}</div>
              <div className="detail-value">
                {orderData.remarkToCustomer || '-'}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AddressAndServiceDetailSection;
